import * as actions from "./consts";
import getAxios from 'services/axios'
import { createCachedFunction } from "../utils";

const axios = getAxios('id');

// Тольуко для текущего юзера
export const updateUser = (params) => (dispath) => {
  return axios.put('/account', params)
    .then( user => {
      dispath(setUsers(user))
      return user;
    })
}

export const changeAvatar = (params) => (dispatch) =>
  axios.post('/account/avatar', params)
    .then( res => {
      // TODO: update store with new image
      // dispatch
      return res;
    })

export const changePassword = (oldPass, pass) => (dispatch) =>
  axios.put('/account/password', {
    old_password: oldPass,
    password: pass,
    password_confirmation: pass,
  })

export const setUsers = (users = []) => ({
  type: actions.SET_USERS,
  users,
})

const cacher = createCachedFunction(() => (dispatch) => {
  return axios.get('/account/team/members')
    .then( users => {
      dispatch(setUsers(Object.values(users)));

      return users;
    })
}, {recursively: true});

export const getTeam = cacher.cachedFunction;
